import axiosInstance from '../../lib/axios';
import { cancellableGet } from '../../lib/cancellableGet';

/** Cross-coach, admin-only console; not /admin/coach/customers/ (a coach's own clients). */
const ROOT = '/admin/sleep-coach';

// Bare object. Pool-wide, not one coach's caseload.
export const fetchCaseloadHealth = () => cancellableGet(`${ROOT}/overview/`);

export const fetchOwnershipHistory = () =>
  cancellableGet(`${ROOT}/ownership-history/`, { params: { limit: 3 } });

export const fetchCoachDirectory = ({ page = 1, limit = 50, q = '', attention = false } = {}) =>
  cancellableGet(`${ROOT}/coaches/`, { params: { page, limit, q, attention } });

export const fetchRoutingPolicy = () => cancellableGet(`${ROOT}/routing-policy/`);

export const updateRoutingPolicy = async (fields) => {
  const response = await axiosInstance.patch(`${ROOT}/routing-policy/`, fields);
  return response.data;
};

// Owner uses a TeamMember id; handling agent uses a User id.
export const fetchReviewConversations = ({
  q,
  filter,
  coachId,
  clientId,
  agentId,
  dateFrom,
  dateTo,
  page = 1,
  limit = 50,
} = {}) => {
  const params = { page, limit };
  if (q) params.q = q;
  if (coachId) params.coach_id = coachId;
  if (clientId) params.client_id = clientId;
  if (agentId) params.agent_id = agentId;
  if (dateFrom) params.date_from = dateFrom;
  if (dateTo) params.date_to = dateTo;
  if (filter && filter !== 'all') params.filter = filter;
  return cancellableGet(`${ROOT}/conversations/`, { params });
};

// The row plus its transcript. page/limit paginate the messages, not the row.
// Reading one writes a transcript_viewed audit row.
export const fetchReviewConversation = (conversationId, { page = 1, limit = 50 } = {}) =>
  cancellableGet(`${ROOT}/conversations/${conversationId}/`, {
    params: { page, limit },
  });

// 204, no body. Closed coaching threads only - an open one is refused.
export const deleteReviewConversation = async (conversationId) => {
  await axiosInstance.delete(`${ROOT}/conversations/${conversationId}/`);
  return conversationId;
};
